import { ApiRef, createApiRef } from '@backstage/core-plugin-api';

export type AccessTokenOptions = {
  cacheOnly?: boolean;
};

export type ConfidenceUserApi = {
  getAccessToken: (options?: AccessTokenOptions) => Promise<string>;
};

type AccessTokenFetcher = (
  options: AccessTokenOptions,
) => Promise<string | undefined>;

export const confidenceUserApiRef: ApiRef<ConfidenceUserApi> = createApiRef({
  id: 'confidence.user',
});

export const createConfidenceUserApi = (): {
  api: ConfidenceUserApi;
  setAccessTokenFetcher: (fetcher: AccessTokenFetcher | undefined) => void;
} => {
  let accessTokenFetcher: AccessTokenFetcher | undefined;
  return {
    api: {
      getAccessToken: async (options = {}) => {
        const token = await accessTokenFetcher?.(options);
        if (!token) {
          throw new Error('Not signed in to Confidence');
        }
        return token;
      },
    },
    setAccessTokenFetcher: fetcher => {
      accessTokenFetcher = fetcher;
    },
  };
};

const defaultConfidenceUserApi = createConfidenceUserApi();

export const confidenceAuth: ConfidenceUserApi = defaultConfidenceUserApi.api;

export const setConfidenceAccessTokenFetcher =
  defaultConfidenceUserApi.setAccessTokenFetcher;
